
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_14yj0_174j7_9",
  "no-gutters": "awsui_no-gutters_14yj0_174j7_45",
  "grid-column": "awsui_grid-column_14yj0_174j7_50",
  "colspan-1": "awsui_colspan-1_14yj0_174j7_61",
  "push-1": "awsui_push-1_14yj0_174j7_65",
  "pull-1": "awsui_pull-1_14yj0_174j7_68",
  "colspan-2": "awsui_colspan-2_14yj0_174j7_71",
  "push-2": "awsui_push-2_14yj0_174j7_75",
  "pull-2": "awsui_pull-2_14yj0_174j7_78",
  "colspan-3": "awsui_colspan-3_14yj0_174j7_81",
  "push-3": "awsui_push-3_14yj0_174j7_85",
  "pull-3": "awsui_pull-3_14yj0_174j7_88",
  "colspan-4": "awsui_colspan-4_14yj0_174j7_91",
  "push-4": "awsui_push-4_14yj0_174j7_95",
  "pull-4": "awsui_pull-4_14yj0_174j7_98",
  "colspan-5": "awsui_colspan-5_14yj0_174j7_101",
  "push-5": "awsui_push-5_14yj0_174j7_105",
  "pull-5": "awsui_pull-5_14yj0_174j7_108",
  "colspan-6": "awsui_colspan-6_14yj0_174j7_111",
  "push-6": "awsui_push-6_14yj0_174j7_115",
  "pull-6": "awsui_pull-6_14yj0_174j7_118",
  "colspan-7": "awsui_colspan-7_14yj0_174j7_121",
  "push-7": "awsui_push-7_14yj0_174j7_125",
  "pull-7": "awsui_pull-7_14yj0_174j7_128",
  "colspan-8": "awsui_colspan-8_14yj0_174j7_131",
  "push-8": "awsui_push-8_14yj0_174j7_135",
  "pull-8": "awsui_pull-8_14yj0_174j7_138",
  "colspan-9": "awsui_colspan-9_14yj0_174j7_141",
  "push-9": "awsui_push-9_14yj0_174j7_145",
  "pull-9": "awsui_pull-9_14yj0_174j7_148",
  "colspan-10": "awsui_colspan-10_14yj0_174j7_151",
  "push-10": "awsui_push-10_14yj0_174j7_155",
  "pull-10": "awsui_pull-10_14yj0_174j7_158",
  "colspan-11": "awsui_colspan-11_14yj0_174j7_161",
  "push-11": "awsui_push-11_14yj0_174j7_165",
  "pull-11": "awsui_pull-11_14yj0_174j7_168",
  "colspan-12": "awsui_colspan-12_14yj0_174j7_171",
  "push-12": "awsui_push-12_14yj0_174j7_175",
  "pull-12": "awsui_pull-12_14yj0_174j7_178",
  "push-0": "awsui_push-0_14yj0_174j7_181",
  "pull-0": "awsui_pull-0_14yj0_174j7_184",
  "offset-1": "awsui_offset-1_14yj0_174j7_187",
  "offset-2": "awsui_offset-2_14yj0_174j7_190",
  "offset-3": "awsui_offset-3_14yj0_174j7_193",
  "offset-4": "awsui_offset-4_14yj0_174j7_196",
  "offset-5": "awsui_offset-5_14yj0_174j7_199",
  "offset-6": "awsui_offset-6_14yj0_174j7_202",
  "offset-7": "awsui_offset-7_14yj0_174j7_205",
  "offset-8": "awsui_offset-8_14yj0_174j7_208",
  "offset-9": "awsui_offset-9_14yj0_174j7_211",
  "offset-10": "awsui_offset-10_14yj0_174j7_214",
  "offset-11": "awsui_offset-11_14yj0_174j7_217",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_174j7_221"
};
  